<div class="flex justify-between items-center p-l-6 p-r-6 chip" [class.w-full]="wFull" [@slideContent]="animationState">
  <div class="accessory-left" (click)="accessoryLeftClick.emit()">
    <ng-content select="[accessory-left]"></ng-content>
  </div>
  <span class="font-s p-l-14 p-r-14 text-overflow-ellipsis">
    {{ text }}
  </span>
  <div class="accessory-right" (click)="accessoryRightClick.emit()">
    <ng-content select="[accessory-right]"></ng-content>
  </div>
</div>
